import React, { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import {
  emptyDonut,
  getTotalValue,
  tooltipContentStyle,
} from "utils/dashboardUtils";

const RevenueSplit = ({ title, data }) => {
  const { t } = useTranslation();

  const primaryValue = data[0]?.value ?? 0;

  const [activeValue, setActiveValue] = useState(primaryValue);

  const totalValue = getTotalValue(data);
  const chartData = totalValue === 0 ? emptyDonut : data;

  return (
    <Col lg={4}>
      <div className="revenue_split donut_card dashboard_common_card">
        <h3 className="fs_20">{t(title)}</h3>

        {/* Donut */}
        <div className="donut_chart py-2">
          <ResponsiveContainer width={175} height={175}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="label"
                innerRadius={60}
                outerRadius={80}
                startAngle={90}
                endAngle={-270}
                stroke="none"
                onMouseEnter={(_, index) => setActiveValue(data[index].value)}
                onMouseLeave={() => setActiveValue(primaryValue)}
              >
                {chartData?.map((item, index) => (
                  <Cell key={index} fill={item.color} />
                ))}
              </Pie>

              {totalValue > 0 && (
                <Tooltip
                  formatter={(value, name) => [`${value}%`, t(name)]}
                  cursor={false}
                  contentStyle={tooltipContentStyle}
                />
              )}
            </PieChart>
          </ResponsiveContainer>

          {/* Center value */}
          <div className="donut_center">
            <span>{activeValue}%</span>
          </div>
        </div>

        {/* Legend */}
        <div className="revenue_donut_legend">
          {data?.map((item) => (
            <div key={item.label} className="donut_legend_item">
              <span className="dot" style={{ background: item.color }} />
              <p>{t(item.label)}</p>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};

export default RevenueSplit;
